module.exports = __webpack_public_path__ + "img/Julia Czekanska.a7f3ca9f.webp";